import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './CallTextInput.styled';
import { Button } from '@virtidev/toolbox';

const CallTextInput = React.forwardRef((props, ref) => {
  const {
    onChange,
    onEnter,
    onFocus,
    onSubmit,
    value,
    placeholder,
    disabled,
    maxLength,
  } = props;
  const handleChange = useCallback(
    (e) => {
      onChange?.(e);
      // use check on whitespace instead of just the enter button to ensure that enter
      // wasn't being used to confirm an IME autocomplete suggestion for example
      if (onEnter && e.target.value.indexOf('\n') !== -1) {
        onEnter();
      }
    },
    [onChange, onEnter]
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (onEnter && e.key === 'Enter') {
        e.preventDefault();
        onEnter();
      }
    },
    [onEnter]
  );

  const handleClickWrapper = useCallback(
    (e) => {
      if (ref?.current && typeof ref.current.focus === 'function') {
        ref.current.focus();
      }
    },
    [ref]
  );

  return (
    <Styled.CallTextInputWrapper
      $disabled={disabled}
      onClick={handleClickWrapper}
    >
      <Styled.CallTextInput
        onFocus={onFocus}
        maxRows={2}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        ref={ref}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
      <Button
        round={true}
        color="turquoise"
        disabled={value === '' || disabled}
        onClick={onSubmit}
        icon="arrow"
      />
    </Styled.CallTextInputWrapper>
  );
});

CallTextInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
};

CallTextInput.displayName = 'CallTextInput';

export default CallTextInput;
